import * as React from "react";
import { ActionOverrideItemDisplayNamePayload } from "actions/collections";
import { SnackbarAddPayload } from "actions/snackbars";
import { validateInput } from "./validations";

export type SubmitNewValueHandler = (
    e: React.FocusEvent<HTMLInputElement>,
    collectionDisplayNames: Record<string, string>
) => void;

type State = {
    inputValue: string | undefined;
    submitNewValue: SubmitNewValueHandler;
    onChangeInput: (e: React.FormEvent<HTMLInputElement>) => void;
    startEditing: () => void;
};

export const useRenameableGridHeaderState = (
    displayName: string,
    fieldName: string,
    dispatchError: (params: SnackbarAddPayload) => void,
    overrideItemDisplayName: (payload: ActionOverrideItemDisplayNamePayload) => void
): State => {
    const [inputValue, setInputValue] = React.useState<string | undefined>(undefined);

    const submitNewValue: SubmitNewValueHandler = (e, collectionDisplayNames) => {
        const newDisplayName = e.currentTarget.value.trim();

        const validationResult = validateInput(newDisplayName, collectionDisplayNames);
        // we cannot coerce the value because the error state its a string;
        if (validationResult === true) {
            overrideItemDisplayName({ newDisplayName, fieldName });
        } else {
            dispatchError({ message: validationResult });
        }
        setInputValue(undefined);
    };

    return {
        inputValue,
        submitNewValue,
        onChangeInput: (e: React.FormEvent<HTMLInputElement>) => {
            setInputValue(e.currentTarget.value);
        },
        startEditing: () => setInputValue(displayName),
    };
};
